import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

/**
 * Guards every authenticated route. By the time this renders, App has
 * already resolved the boot-time silent refresh (see App.tsx), so `status`
 * here is settled — 'authenticated' or 'unauthenticated', never 'idle'/
 * 'loading'. A session that later goes away (logout, or a failed refresh
 * after a 401) flips `status` and this re-renders on its own, redirecting.
 */
export function RequireAuth({ children }: { children: JSX.Element }) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
